import { createAction, props } from '@ngrx/store';

export const trackedMocafirst = createAction(
  '[Page View] Pushed MOCAFIRST Path to be tracked.',
  props<{ payload: { consent: string; category: string; topcategory: string; pageType: string } }>()
);

export const noOpServer = createAction(
  '[NoOp] No action for Mocafirst on Server',
);
